import './utils/index'
import dragPicture from './utils/slider'
import priorityNav from './utils/priority-nav'
import initBlog from './utils/blog'
import Vue from 'vue'
import FavoriteList from './components/favorites/FavoriteList'
import FavoriteListItem from './components/favorites/FavoriteListItem'
import FavoriteButton from './components/favorites/FavoriteButton'
import store from './store'
import FavoriteHeaderButton from './components/favorites/FavoriteHeaderButton'
import ProductOrderTotal from './components/shop-card/ProductOrderTotal'
import ProductOrderSelects from './components/shop-card/ProductOrderSelects'
import ProductOrder from './components/shop-card/ProductOrder'
import ShopCardHeaderButton from './components/shop-card/ShopCardHeaderButton'
import FavoriteProductButton from './components/favorites/FavoriteProductButton'
import ShopCardIndex from './components/shop-card/ShopCardIndex'
// Из bootstrap-vue фронтенду нужны <b-button>, <b-spinner> и $bvModal
// (ShopCartOrderForm показывает им ошибку отправки заказа). Полный
// плагин и набор иконок тянули в сборку сотни килобайт неиспользуемого кода.
import { ButtonPlugin, SpinnerPlugin, ModalPlugin } from 'bootstrap-vue'
import CatalogShowMoreBtn from './components/catalog/CatalogShowMoreBtn'
import CatalogItem from './components/catalog/CatalogItem'
import CallbackForm from './components/callback/CallbackForm'
import ContactCallbackForm from './components/callback/ContactCallbackForm'
import AlbumShowMoreBtn from './components/album/AlbumShowMoreBtn'
import AlbumItem from './components/album/AlbumItem'
import Search from './components/Search/Search'
import SearchForm from './components/Search/SearchForm'
import VueTheMask from 'vue-the-mask'

initBlog()

Vue.use(VueTheMask)
window.Vue = Vue

Vue.use(ButtonPlugin)
Vue.use(SpinnerPlugin)
Vue.use(ModalPlugin)

Vue.component('favorite-header-button', FavoriteHeaderButton)
Vue.component('favorite-list', FavoriteList)
Vue.component('favorite-list-item', FavoriteListItem)
Vue.component('favorite-product-button', FavoriteProductButton)
Vue.component('favorite-button', FavoriteButton)
Vue.component('shop-card-header-button', ShopCardHeaderButton)
Vue.component('product-order', ProductOrder)
Vue.component('product-order-total', ProductOrderTotal)
Vue.component('product-order-selects', ProductOrderSelects)
Vue.component('shop-card-index', ShopCardIndex)

Vue.component('callback-form-modal', CallbackForm)
Vue.component('callback-form-contact', ContactCallbackForm)

Vue.component('show-more-album-btn', AlbumShowMoreBtn)
Vue.component('album-more-items', AlbumItem)

Vue.component('show-more-btn', CatalogShowMoreBtn)
Vue.component('catalog-more-items', CatalogItem)

Vue.component('search', Search)
Vue.component('search-form', SearchForm)

const lang = document.querySelector('html').getAttribute('lang')

Vue.prototype.$currentLang = lang
Vue.prototype.$lang = (value) => {
  if (value) {
    return value[lang]
  } else {
    return null
  }
}

const app = new Vue({
  store,
  el: '#app',
  beforeMount () {
    this.$store.dispatch('favorite/index')
    this.$store.dispatch('shop_card/index')
  },
  mounted() {
      dragPicture()
      priorityNav()
  }
})
